var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '8', height: '5', viewBox: '0 0 8 5', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M0 1c0 .256.098.512.293.707l3 3a.999.999 0 001.414 0l3-3A.999.999 0 106.293.293L4 2.586 1.707.293A.999.999 0 000 1', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function arrow(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};